import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import React, { useEffect, useState } from 'react'
import {
  useCreatePasswordMutation,
  useVerifyLinkMutation,
} from '../../../redux-toolkits/auth/auth.slice'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Button } from '../../../components/button'
import { TextInput } from '../../../components/inputs/textInput'
import { AuthWrapper } from '../../../components/wrapper/AuthWrapper'
import { LoadingOval } from '../../../components/spinner/Spinner'

const validate = Yup.object().shape({
  password: Yup.string()
    .min(2, 'Too Short!')
    .max(50, 'Too Long!')
    .required('Required'),
  confirmPassword: Yup.string()
    .required('Required')
    .oneOf([Yup.ref('password')], 'Passwords do not match.'),
})

const CreatePasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const [user, setUser] = useState<
    | {
        id: string
        fullName: string
        email: string
      }
    | undefined
  >({
    id: '',
    fullName: '',
    email: '',
  })

  const [verify, { isLoading }] = useVerifyLinkMutation()
  const [createPassword, { isLoading: isCreatePassword }] =
    useCreatePasswordMutation()

  const navigate = useNavigate()
  const token = searchParams.get('token') ?? ''

  // const handleVerifyLink = useCallback(async () => {
  //   const { data } = await verify({ token })

  //   if (data?.success) {
  //     setUser(data?.data?.stakeholder)
  //   } else {
  //     navigate('/auth/login')
  //   }
  // }, [token])

  // useEffect(() => {
  //   handleVerifyLink()
  // }, [])

  // const handleVerifyLink = useCallback(async () => {
  //   const { data } = await verify({ token })

  //   if (data?.success) {
  //     setUser(data?.data?.stakeholder)
  //   } else {
  //     navigate('/auth/login')
  //   }
  // }, [token, verify, navigate]) // Add ALL dependencies

  // useEffect(() => {
  //   handleVerifyLink()
  // }, [handleVerifyLink]) // Include handleVerifyLink

  useEffect(() => {
    let isMounted = true

    const handleVerifyLink = async () => {
      const { data } = await verify({ token })

      if (isMounted) {
        if (data?.success) {
          setUser(data?.data?.stakeholder)
        } else {
          navigate('/auth/login')
        }
      }
    }

    handleVerifyLink()

    return () => {
      isMounted = false // Cleanup
    }
  }, [token]) // Add token to dependency array

  if (isLoading) {
    return (
      <div className="h-screen w-screen items-center flex justify-center">
        <LoadingOval color="#000000" loaderHeight="40" loaderWidth="40" />
      </div>
    )
  }

  return (
    <div className="h-screen w-screen items-center flex justify-center">
      <AuthWrapper
        header={`Hi, ${user?.fullName}`}
        subTitle="Welcome to Good Stakeholders platform. Kindly create your login password."
        className="w-full max-w-[420px]"
      >
        <Formik
          initialValues={{
            password: '',
            confirmPassword: '',
          }}
          validationSchema={validate}
          onSubmit={async (values) => {
            const payload = {
              token,
              ...values,
            }
            const response = await createPassword(payload)
            if (response.data?.success) {
              navigate('/auth/login')
            }
          }}
        >
          {({ values, handleBlur, handleChange, errors, touched, isValid }) => (
            <Form className="flex flex-col gap-6">
              <div className="flex flex-col gap-6">
                <TextInput
                  type="password"
                  name="password"
                  value={values.password}
                  placeholder="Password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  hasIcon={false}
                  inputClass=""
                  className=""
                  errors={
                    touched.password && errors.password ? errors.password : ''
                  }
                />

                <div className="flex flex-col gap-3">
                  <TextInput
                    type="password"
                    name="confirmPassword"
                    value={values.confirmPassword}
                    placeholder="Confirm password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    hasIcon={false}
                    inputClass=""
                    className=""
                    errors={
                      touched.confirmPassword && errors.confirmPassword
                        ? errors.confirmPassword
                        : ''
                    }
                  />
                </div>
              </div>

              <Button
                type="submit"
                primary
                label="Create password"
                disabled={!isValid || isCreatePassword}
                loading={isCreatePassword}
              />
            </Form>
          )}
        </Formik>
      </AuthWrapper>
    </div>
  )
}

export default CreatePasswordPage
